import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

const PAGE_TITLE_POSTFIX = ' | DOTS';

/**
 * Custom title service that adds a postfix to the page title.
 */
@Injectable()
export class CustomTitleService extends Title {
  public override setTitle(newTitle: string): void {
    super.setTitle(`${newTitle}${PAGE_TITLE_POSTFIX}`);
  }
}
